import { get } from 'lodash';
import store from '@/store';

export default {
  gateway: null,
  init() {
    const self = this;
    const { config } = store.getters;
    const Gateway = this.library().slave;

    this.gateway = new Gateway({
      slaveId: config.gateway.slaveId,
      allowedOrigins: config.gateway.masterOrigins,
      debug: true,
      data: {},
      eventPropagation: {
        click: true,
      },
      eventListeners: {},
      load(message) {
        const { data } = message;
        const user = get(data, 'user');
        const platform = get(data, 'config');

        store.dispatch('loadConfig', {
          wheelIdentifier: platform.cpvUuid,
          locale: user.language,
          app: 'RouletteAdmin',
          timezoneOffset: platform.company ? platform.company.timezoneOffset : null,
        }).then(() => {
          store.dispatch('setPlatform', {
            productId: platform.cpvUuid,
          }).then(() => {
            self.gateway.sendMessage({
              action: 'Slave.Loaded',
              data: {},
            });
          });

          const companyTimezoneOffset = platform.company ? platform.company.timezoneOffset : null;
          const userTimezoneOffset = user.timezoneOffset || companyTimezoneOffset;

          store.dispatch('setUser', {
            user: {
              id: user.uuid,
              uuid: user.uuid,
              firstName: user.firstName,
              lastName: user.lastName,
              language: user.language,
              timezoneOffset: userTimezoneOffset,
              auth: {
                token: user.auth.accessToken,
              },
            },
          });

          self.setListeners();
        });
      },
    });
  },
  library() {
    return window.gravity.gateway;
  },
  onAuthorizationChanged(message) {
    store.dispatch('setUser', message.data);
  },
  setListeners() {
    this.gateway.on('User.AuthorizationChanged', this.onAuthorizationChanged.bind(this));
  },
};
